"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slideTabRow = void 0;
var _constants = require("./constants");
var slideTabRow = function slideTabRow() {
  var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'left';
  var slider = document.getElementById(_constants.DEFAULT_TAB_LINKS_CONTAINER_ID);
  if (!slider) {
    return;
  }
  if (direction === 'left') {
    slider.scrollLeft -= _constants.DEFAULT_TAB_LINKS_SLIDE_VALUE;
  }
  if (direction === 'right') {
    slider.scrollLeft += _constants.DEFAULT_TAB_LINKS_SLIDE_VALUE;
  }
};
exports.slideTabRow = slideTabRow;